import * as React from "react";
import type { SVGProps } from "react";
const SvgPaybybank = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fill="#139fc6"
      d="M10.712 4.054a2.178 2.178 0 0 0-4.35 0 2.178 2.178 0 0 0 4.35 0"
    />
    <path
      fill="#005198"
      d="M8.54 18.514a.88.88 0 0 1-.877-.872V4.054a.878.878 0 0 1 1.756 0v13.589a.88.88 0 0 1-.878.87m3.099-5.037a.88.88 0 0 1-.879-.864V8.228a.878.878 0 1 1 1.757 0v4.377a.88.88 0 0 1-.879.864m3.091.007a.88.88 0 0 1-.878-.864V8.734a.878.878 0 1 1 1.757 0v3.878a.88.88 0 0 1-.878.864"
    />
    <path
      fill="#005198"
      d="M13.073 21.992a5.18 5.18 0 0 1-5.467-4.876v-.225a4.11 4.11 0 0 0-3.372-3.745.867.867 0 0 1 .267-1.714 5.89 5.89 0 0 1 4.862 5.48c0 1.672 1.272 3.365 3.71 3.365 1.278 0 3.765-1.16 3.765-3.288v-6.927a.878.878 0 1 1 1.757 0v6.906c0 2.108-2.108 5.023-5.522 5.023"
    />
  </svg>
);
export default SvgPaybybank;
